module.exports = __webpack_public_path__ + "static/img/img_logo.3f16c530.png";